var _style, _path, _path2, _path3, _path4, _path5, _path6, _polygon, _polygon2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMailSent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x34_306f7a5-0830-4d34-917a-62986225c636",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 737.6 734.7",
    style: {
      enableBackground: "new 0 0 737.6 734.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:#00B4AA;}\r\n\t.st2{fill:#F5F5F5;}\r\n\t.st3{fill:#FFFFFF;}\r\n\t.st4{opacity:0.3;enable-background:new    ;}\r\n\t.st5{display:none;fill:url(#SVGID_2_);}\r\n\t.st6{display:none;fill:#FFFFFF;}\r\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 600.0151,
    y1: -83.4203,
    x2: 600.0151,
    y2: 651.2751,
    gradientTransform: "matrix(1 0 0 -1 -231.2 651.2498)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.12
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.1
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M737.6,301.8c0.1-27.5-5.6-34.7-18-45.1L385.9,5.5c-9.7-7.3-23-7.4-32.7-0.1L25.4,249.5 C12.9,259.9,1.3,272,1.2,299.4H0.9L0,675.4l0,0v16.7c-0.1,22.6,18.3,41,40.9,41.1c0,0,0,0,0,0h16.2l0,0l310.9,0.7l327,0.7 c22.6,0.1,41-18.3,41.1-40.9c0,0,0,0,0,0l0.9-392.1L737.6,301.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7,301.2l723,1.6l0,0l-0.8,350c-0.1,39.6-32.3,71.7-71.9,71.6l-580.8-1.3C37.6,723,6.1,691.4,6.2,652.5L7,301.2 L7,301.2L7,301.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M7,301.1L6.2,666.8c-0.1,31,25,56.2,56,56.3l610.8,1.3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M730.1,302.8l-0.8,365.6c-0.1,31-25.3,56.1-56.3,56L62.3,723"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M353.1,15.3l-322,237.3c-12.2,10.1-23.7,21.9-23.7,48.6l723.4,2.3c0.1-26.7-5.5-33.7-17.7-43.9L385.2,15.4 C375.7,8.3,362.7,8.2,353.1,15.3z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M353.1,15.3l-322,237.3c-12.2,10.1-23.7,21.9-23.7,48.6l723.4,2.3c0.1-26.7-5.5-33.7-17.7-43.9L385.2,15.4 C375.7,8.3,362.7,8.2,353.1,15.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 640.8058,
    y1: 192.3834,
    x2: 640.8058,
    y2: 622.3822,
    gradientTransform: "matrix(1 2.268926e-03 2.268926e-03 -1 -231.9677 649.7687)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.12
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.09
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.02
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "651.8,97.9 564.3,29.2 352.8,297.1 239.1,209 167.9,299.5 333.4,425.8 333.4,425.8 374.4,458.8 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "645.4,96.2 566.1,35.4 355.9,309.4 239.2,219.9 178.4,299.2 334.7,419 334.7,419 374.8,449 "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailSent);
export default __webpack_public_path__ + "static/media/mail_sent.2d5ebda21887b9795dc2fd5b7d70057d.svg";
export { ForwardRef as ReactComponent };